<template>
  <div class="xpage-content sc-page-content">
    <div class="sc-page-content-section"></div>
    <div class="xpage-content-page sc-page-content-page">
      <div class="xtitlearea sc-titlearea">
        <h2 class="sc-section-header">Certifications and Disbursements</h2>
        <Comments
          :certification="certification"
          @commentAdded="$emit('commentAdded')"
        ></Comments>
      </div>
    </div>
    <div class="xpage-content-page sc-page-content-page">
      <div>
        <CertificationsNavbar :certifications="certifications" />
        <div class="sc-container" id="certification">
          <CertificationForm
            :certification="certification"
            @certificationUpdated="$emit('certificationUpdated', $event)"
          />
          <disbursements-section
            :certification="certification"
            @disbursementUpdated="$emit('disbursementUpdated', $event)"
            @disbursementAdded="$emit('disbursementAdded', $event)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, computed } from "vue";
import { CertificationVM, CertificationSlimVM } from "@/types/certifications";
import { DisbursementVM, DisbursementAddedEvent } from "@/types/disbursements";
import Comments from "@/components/v2/certifications/Comments.vue";
import CertificationForm from "@/components/v2/certifications/CertificationForm.vue";
import CertificationsNavbar from "@/components/v2/certifications/CertificationsNavbar.vue";
import DisbursementsSection from "@/components/v2/disbursements/DisbursementsSection.vue";

const props = defineProps<{ certification: CertificationVM }>();

const emit = defineEmits<{
  (e: "commentAdded"): void;
  (e: "certificationUpdated", value: CertificationVM): void;
  (
    e: "disbursementUpdated",
    value: {
      disbursement: DisbursementVM;
      disbursements: DisbursementVM[];
    }
  ): void;
  (e: "disbursementAdded", value: DisbursementAddedEvent): void;
}>();

const certifications = computed<CertificationSlimVM[]>(
  () => props.certification?.certifications || []
);
</script>
<style scoped>
.sc-page-content {
  padding: 15px;
}

.sc-section-header {
  color: #000;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 0;
}

.sc-section-header {
  margin-bottom: 14px;
}

.xpage-content-page-section {
  background: #f2f3f5;
}

.xpage-content {
  display: flex;
  flex-direction: column;
}
</style>
<style scoped src="@/assets/css/certifications/certification-form.css"></style>
